/* eslint-disable camelcase */
import { css } from '@emotion/core';

export const $icon = css`
  margin-right: 10px;
`;

export const $groups = css`
  margin: 0 0 0 10px;
`;

export const $group = css`
  padding: 0 0 0 35px;
  position: relative;
`;

export const $groupLabel = css`
  display: inline-block;
  left: 0;
  position: absolute;
  top: 12px;
`;

export const $option = (isActive) => ({ colors }) => {
  const borderColor = isActive ? colors.ui.core[25] : colors.ui.neutral[100];
  const borderColorHover = isActive ? colors.ui.core[100] : colors.ui.neutral[200];
  const borderColorFocus = isActive ? colors.ui.core[500] : colors.ui.neutral[300];
  const color = isActive ? colors.ui.core[500] : colors.ui.neutral[600];

  return css`
    background-color: ${colors.ui.white[500]};
    border: 1px solid ${borderColor};
    border-radius: 20px;
    color: ${color};
    cursor: pointer;
    margin: 5px;
    outline: none;
    padding: 8px 12px;
    transition: 200ms border-color;

    &:hover {
      border-color: ${borderColorHover};
    }

    &:active,
    &:focus {
      border-color: ${borderColorFocus};
    }
  `;
};
